export default "__VITE_ASSET__DLGCRqxq__"